import { useEffect, useState } from "react";
import { FullOptionCreater } from "core/utils/full-option-creater.utils";
import { removeDuplicates } from "core/utils/remove-duplicate.utils";

const defaultOption = [
  {
    label: "انتخاب کنید...",
    options: [],
  },
];

const AllObject = { value: 0, label: "همه" };

export const useOptionUpdater = (
  mutationData: any,
  idKey: string,
  labelKey: string,
  extraCondition = true,
  prependAllObject = false,
  dataKey?: string,
  uniqueField?: string
) => {
  const [options, setOptions] = useState<any[]>(defaultOption);

  useEffect(() => {
    if (
      mutationData?.isSuccess &&
      mutationData?.data &&
      mutationData?.data?.data &&
      extraCondition
    ) {
      const result = dataKey
        ? mutationData.data.data.result[dataKey]
        : mutationData.data.data.result;

      if (result) {
        let newState: any = FullOptionCreater(result, idKey, labelKey);
        if (newState[0]?.options?.length > 0) {
          if (uniqueField)
            newState[0].options = removeDuplicates(
              newState[0].options,
              uniqueField
            );

          if (prependAllObject) newState[0]?.options.unshift(AllObject);

          setOptions(newState);
        }
      }
    }
  }, [mutationData?.data, mutationData?.isSuccess]);

  return { options, setOptions };
};
